export type EprintToast = {
  duration: number
  showClose: boolean
  dangerouslyUseHTMLString?: boolean
  message: string
  type: 'error' | 'warning'
}

export function pdfResultErrorToast(serverMessage: string): EprintToast {
  if (serverMessage === '不正なページ数です') {
    return {
      duration: 0,
      showClose: true,
      dangerouslyUseHTMLString: true,
      message: `送信失敗しました。${serverMessage}<br><br>ふりがなが長すぎるなどの理由により、フォーマットが崩れている可能性があります。<br>入力内容を確認し、修正してください。<br>ブラウザのキャッシュを削除するか、更新してください。`,
      type: 'error'
    }
  }
  if (
    serverMessage ===
    'バージョンエラーです。ブラウザのキャッシュを削除するか、更新してください。'
  ) {
    return {
      duration: 0,
      showClose: true,
      dangerouslyUseHTMLString: true,
      message: `送信失敗しました。${serverMessage}<br><br>今見ている画面が古い可能性があります。<br>ブラウザのキャッシュを削除するか、更新してください。`,
      type: 'error'
    }
  }
  return {
    duration: 0,
    showClose: true,
    message: `送信失敗しました。${serverMessage}`,
    type: 'error'
  }
}

export type AxiosLikeError = {
  code?: string
  message?: string
  response?: { status: number; data?: { message?: string } }
}

export function isAxiosTimeout(error: AxiosLikeError): boolean {
  return !!(
    error &&
    (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || ''))
  )
}
